import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
//import ShowRanks from "./Components/RanksOverView/RanksOverView";
//  <ShowRanks> </ShowRanks>
// Fix for pre-render
if (typeof window !== "undefined") {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("PaymentSection")
  );
}
